import { ListChecks } from "lucide-react";
import {
  SolveActionsParamsSchema,
  defaultSolveActionsParams,
  type SolveActionsParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { SolveActionsWidget } from "./Component.js";
import { SolveActionsEditor } from "./Editor.js";
import type { SolveActionsView } from "./types.js";

export const solveActionsDef: SqlWidgetDef<
  SolveActionsParams,
  SolveActionsView
> = {
  kind: "solveActions",
  label: "SOLVE Actions",
  modes: ["dashboard"],
  // `singleton: false` and `allowMultiple: true` are the same decision stated
  // in the two registries this kind lives in: several independently configured
  // instances on one Home is the agreed behaviour.
  singleton: false,
  defaultSize: { w: 640, h: 360 },
  defaultParams: defaultSolveActionsParams,
  Component: SolveActionsWidget,
  storage: "sql",
  schema: SolveActionsParamsSchema,
  accent: "pb-tint-2",
  icon: ListChecks,
  subtitle: "Actions across your SOLVEs",
  defaultRoster: false,
  category: "multi",
  layout: { col: 1, row: 1, width: 640, height: 360 },
  dashboard: {
    icon: ListChecks,
    defaultWidth: "wide",
    category: "Operations",
    allowMultiple: true,
    supportsTitleOverride: true,
    EditorForm: SolveActionsEditor,
  },
};

registerWidget(solveActionsDef);
